export default {
  namespaced: true,
  state() {
    return {
      active: false,
      title: "",
      message: "",
      type: "info"
    };
  },
  mutations: {
    SET_ALERT(state, { active, title, message, type }) {
      state.active = active;
      state.title = title;
      state.message = message;
      state.type = type;
    }
  },
  actions: {
    open({ commit }, { title, message, type }) {
      commit("SET_ALERT", {
        active: true,
        title,
        message,
        type
      });
    },
    close({ commit }) {
      commit("SET_ALERT", {
        active: false,
        title: "",
        message: "",
        type: "info"
      });
    }
  }
};
